















































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import moment from "moment";
import PrestadorAutocomplete from "@/components/saude/PrestadorAutocomplete.vue";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { OrcamentoModel } from "@/models/cadastros/saude/atendimento/orcamento/OrcamentoModel";
import { PrestadorResumidoModel } from "@/models/cadastros/saude/PrestadorResumidoModel";
import { saudeAtendimentoService } from '@/service/cadastro/saude/atendimento/SaudeAtendimentoService';
import { RetornoMensagemModel } from '@/models/cadastros/saude/RetornoMensagemModel';
import TipoAtendimentoModel from '@/models/cadastros/saude/TipoAtendimentoModel';

@Component({
  components: {
    PrestadorAutocomplete,
    GsModalDialog
  },
})
export default class Orcamento extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly!: boolean;

  orcamento: OrcamentoModel = {
    valorPrestador: "0",
    valorAdicionalEstimado: "0",
    valorAssociado: "0",
    descricao: "",
    dataAgendamento: "",
    horaAgendamento: "",
  };

  @Prop({ required: false })
  orcamentoReadonly!: OrcamentoModel;

  dateString? = moment().format("DD/MM/YYYY");
  dataAgenda? = moment().format("YYYY-MM-DD");

  idEspecialidade = 0;
  tipoAtendimentoString = "";

  exibeModal = false;
  titulo = "";
  mensagem = "";
  sucesso = false;

  get minDate() {
    return moment().format("YYYY-MM-DD");
  }

  mounted() {
    if(this.$route.params.idAtendimento) {
      saudeAtendimentoService.obterDetalheAtendimento(Number(this.$route.params.idAtendimento))
      .then(res => {
        this.idEspecialidade = res.especialidade.id;
        this.tipoAtendimentoString = res.especialidade.tipoAtendimento;
        if(this.tipoAtendimentoString == "REMOCAO") {
          this.dataAgenda = res.data;
          this.dateString = moment(res.data).format("DD/MM/YYYY");
          this.orcamento.horaAgendamento = res.hora.substring(0, 5);
        }
      });
    }
  }

  get isRemocao() {
    return this.tipoAtendimentoString == "REMOCAO";
  }

  parseDate(date: string) {
    if (!date) return null;
    const parsedDate = moment(date, "DD/MM/YYYY", true);
    if (parsedDate.isValid()) {
      return parsedDate.format("YYYY-MM-DD");
    } else {
      this.dateString = "";
      return null;
    }
  }

  get valorPrestadorDecimal(): string | undefined {
    if(!this.orcamento.valorPrestador){
      return undefined;
    }

    const intPart = this.orcamento.valorPrestador.split(",")[0].replace(/\D/g, "");
    const decimalPart = this.orcamento.valorPrestador.split(",")[1];

    return `${intPart}.${decimalPart}`;
  }

  selectDate() {
    this.dateString = moment(this.dataAgenda).format("DD/MM/YYYY");
  }

  enviarOrcamento() {
    if(this.$route.params.idAtendimento) {
      this.orcamento.dataAgendamento = this.dataAgenda || "";
      
      saudeAtendimentoService.incluirOrcamento(Number(this.$route.params.idAtendimento), this.orcamento)
      .then((res: RetornoMensagemModel) => {
        this.mensagem = res.mensagem;
        this.titulo = "Sucesso";
        this.sucesso = true;
      })
      .catch((err: Error) => {
        this.mensagem = err.message;
        this.titulo = "Erro";
        this.sucesso = false;
      })
      .finally(() => {
        this.exibeModal = true;
      }) 
    } else {
      this.mensagem = "Ocorreu um erro ao identificar a solicitação de orçamento, por favor, retorne para a página de pesquisa e inicie o processo novamente.";
      this.titulo = "Erro";
      this.sucesso = false;
      this.exibeModal = true;
    }
  }

  fecharModal() {
    if(this.sucesso) {
      this.$router.push({ name: "ListaAtendimentos" });
    } else {
      this.exibeModal = false;
    }
  }

  cancelar() {
    this.$router.back();
  }
}
